import React from 'react'
import PropTypes from 'prop-types'
import TooltipMUI from '@material-ui/core/Tooltip'

/**
 * Componente Tooltip que envuelve el Tooltip de Material-UI.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {React.ReactNode} props.children - Elementos hijos que serán envueltos por el Tooltip.
 * @param {boolean} [props.followCursor=true] - Define si el Tooltip debe seguir el cursor.
 * @returns {React.ReactElement} - Elemento React Tooltip.
 *
 * @example
 * <Tooltip followCursor={false}>
 *   <button>Hover me</button>
 * </Tooltip>
 */
const Tooltip = ({ children, followCursor = true, ...props }) => {
  return (
    <TooltipMUI arrow={true} followCursor={followCursor} {...props}>
      {children}
    </TooltipMUI>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  followCursor: PropTypes.bool
}

Tooltip.defaultProps = {
  followCursor: true
}

export default Tooltip
